// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sort__order__button[data-v-7a488ea8] {\n  padding: 5px;\n  background-color: #1eb2d0;\n  color: white;\n  border-radius: 50%;\n  cursor: pointer;\n  height: 17px;\n  width: 17px;\n}\n.sort__order__value[data-v-7a488ea8] {\n  width: 15px;\n  margin: 0 10px;\n  display: inline-block;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
